export default __webpack_public_path__ + "static/media/GrooveB_120bpm_Tanggu.3e1411b4.mp3";